export default {
  'YouTube and High Definition Videos': 'YouTube ve Yüksek Çözünürlüklü Videolar',
  'Story videos (Instagram/Snaps/TikTok)': 'Hikaye videoları (Instagram/Snaps/TikTok)',
  'Facebook and Instagram Feed videos': 'Facebook ve Instagram Besleme videoları',
  'Facebook and Twitter Portrait Videos': 'Facebook ve Twitter Portre Videoları',
  'Twitter and Facebbok Landscape Videos': 'Twitter ve Facebbok Manzara Videoları',
  'Facebook Cover Videos And Blog Banners': 'Facebook Kapak Videoları ve Blog Afişleri',
  'Fit': 'Uydur',
  'Fill': 'Doldur',
}